import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ToastService } from '../../../../shared/services/toast.service';
import { MessagesService } from '../../../../shared/services/messages-service.service';
import { BulkMessageSummary, MessageCreateDialogData, ProjectItem, ReviewerItem, RoleItem } from './message.interface';
import { Observable } from 'rxjs';
import { constants } from '../../../../shared/constants/constants';
import { CreateDiscussionComponent } from './modals/create-discussion/create-discussion.component';
import { FirebaseMessagingService } from '../../../../shared/services/firebase-messaging.service';
import { map } from 'rxjs/operators';
import { Reviewer } from '../people/people.interface';
import { MessageComponent } from './message.component';

@Injectable({
  providedIn: 'root'
})
export class MessageComponentService {
  ref: DynamicDialogRef | undefined;
  viewDiscussionData: any={};
  from = '';
  constructor(  private dialogService: DialogService,
    private toast: ToastService,
    private messagesService: MessagesService,
    private firebaseMessagingService: FirebaseMessagingService) { }

  generateDialogData(node:any): MessageCreateDialogData{
    let nodeData:MessageCreateDialogData;
    switch(node.node_type){
      case 'PROJECT':{
        nodeData = {
          projectId: node.key,
          roleId: null,
          reviewerId: null,
          msgType: node.node_type,
          title: node.label,
          status: node.data.status,
          node: node
        };
        break;
      }
      case 'ROLE':{
        nodeData = {
          projectId: node.parent.key,
          roleId: node.key,
          reviewerId: null,
          msgType: node.node_type,
          title: node.label,
          status: node.data.status,
          node: node
        };
        if(node.data.status){
          nodeData.status = node.data.status;
        }
        break;
      }
      case 'REVIEWER':{
        nodeData = {
          projectId: node.data.projectId,
          roleId: node.data.roleId,
          reviewerId: node.data._id,
          msgType: node.node_type,
          title: node.label,
          status: node.data.status,
          node: node,
          formerlyAssigned: node.data.status !== constants.positionStatus.occupied,
          isPresumptive: node.isPresumptive || false
        };
        break;
      }
      default: {
        nodeData = {
          projectId: node.key,
          roleId: null,
          reviewerId: null,
          msgType: node.node_type,
          title: node.label,
          status: node.data.status,
          node: node
        };
        break;
      }
    }
    return nodeData;
  }
    generateDialogDataRole(node:any): MessageCreateDialogData{
    let nodeData:MessageCreateDialogData;
    
    nodeData = {
          projectId: node.parent.key,
          roleId: node.key,
          reviewerId: null,
          msgType: node.node_type,
          title: node.label,
          status: node.data.status,
          node: node
        };
    
    return nodeData;
  }

  generateDialogDataReviewer(node:any): MessageCreateDialogData{
    let nodeData:MessageCreateDialogData;
    
    nodeData = {
      projectId: node.projectId,
      roleId: node.roleId,
      reviewerId: node.reviewer._id,
      msgType: 'REVIEWER',
      title:`${node.reviewer.firstName} ${node.reviewer.lastName}`,
      status: node.status,
      node: node,
      formerlyAssigned: node.status !== constants.positionStatus.occupied
    };
    
    return nodeData;
  }
  openCreateDiscussion(node:{msgType:string,projectId:string,roleId:string,reviewerId:string,reviewer:ReviewerItem,status:string, from?: string, presumptive?: boolean}): void {
      this.firebaseMessagingService.getFirmDiscussionsOnce(node.projectId,node.roleId,node.reviewerId)
      .pipe(
        map(res => {
          let firmDiscussionSnapshots = res ? {...res} : null;
      
          if (firmDiscussionSnapshots && Object.keys(firmDiscussionSnapshots).length > 0) {
            // got to messaging view and open selected discussions
            this.from = node.from || '';
            delete node.from;
            this.setupViewData(node);
            this.openMessageDiscussionsViewDialog();
          } else {
            this.openNewMessageDialog(this.generateDialogDataReviewer(node));
          }
        })
      )
      .subscribe({
        error: () => {
          this.openNewMessageDialog(this.generateDialogDataReviewer(node));
        }
      });     
  }

  setupViewData(reviewerNodeData:any){
    this.viewDiscussionData = reviewerNodeData;
  }

  hasPendingViewData(){
    return Object.keys(this.viewDiscussionData).length > 0;
  }

  getPendingViewData(){
    return this.viewDiscussionData;
  }

  clearPendingViewData(){
    this.viewDiscussionData = {};
  }


  generateProjectNode(project:ProjectItem,index:number){
    let roles:any[] = [];
    Object.values(project.roles).forEach((role)=>{
      roles.push(this.generateRoleNode(role,project));
    })
    return {
      key: project._id,
      label: project.codeName,
      data: project,
      children: roles,
      node_type:'PROJECT'
    }
  }

  generateRoleNode(role:RoleItem,project:ProjectItem){
    let reviewers:any[] = [];
    Object.values(role.reviewers).forEach((reviewer)=>{
      reviewers.push(this.generateReviewerNode(reviewer,project._id,role._id));
    })
    return {
      key: role._id,
      label: role.roleType,
      data: role,
      projectId: project._id,
      children: reviewers,
      node_type:'ROLE'
    }
  }
  generateReviewerNode(reviewer:ReviewerItem,projectId:string,roleId:string){
    return {
      key: reviewer._id,
      label: `${reviewer.firstName} ${reviewer.lastName}`,
      data: {...reviewer,projectId,roleId},
      icon: 'person',
      status:reviewer.status,
      node_type:'REVIEWER',
      isPresumptivelyPending: reviewer.presumptive || false
    }
  }
  
  openNewMessageDialog(data:MessageCreateDialogData, headerTitle = 'Group message'){
    this.ref = this.dialogService.open(CreateDiscussionComponent, {
      data: data,
      header: headerTitle,
      width: '660px',
      contentStyle: { overflow: 'auto' },
      breakpoints: {
        '575px': '90vw' 
      }
    });
    this.ref.onClose.subscribe((message: any) => {
      if (message === 'success') {   
          this.toast.showSuccess('Message sent');    
      }
      });
  }
  /**
   * MP-5692: compose one message for an explicit set of positions (staff-tab bulk Message).
   * Resolves with the per-recipient summary, or undefined when the dialog is dismissed.
   */
  openBulkMessageDialog(data: { projectId: string; positionIds: string[]; recipientNames: string[] }): Observable<BulkMessageSummary | undefined> {
    const dialogData: MessageCreateDialogData = {
      projectId: data.projectId,
      roleId: null,
      reviewerId: null,
      msgType: constants.messageType.reviewers,
      title: `${data.positionIds.length} candidates`,
      node: null,
      positionIds: data.positionIds,
      recipientNames: data.recipientNames
    };
    this.ref = this.dialogService.open(CreateDiscussionComponent, {
      data: dialogData,
      header: `Message ${data.positionIds.length} candidate${data.positionIds.length === 1 ? '' : 's'}`,
      width: '660px',
      contentStyle: { overflow: 'auto' },
      breakpoints: {
        '575px': '90vw'
      }
    });
    return this.ref.onClose;
  }

  openMessageDiscussionsViewDialog(){
    this.ref = this.dialogService.open(MessageComponent, {
      data:{
        from: this.from ? this.from : '',
        isPresumptive: this.viewDiscussionData.presumptive,
        isOpenComponentFromModal: true
      },
      header: 'Messaging',
      width: '80vw',
      contentStyle: { 'overflow-y': 'scroll' },
      breakpoints: {
        '575px': '90vw' 
      }
    });
    this.ref.onClose.subscribe((message: any) => {
      // if (message === 'success') {   
      //     this.toast.showSuccess('Discussion Created Successfully');    
      // }
      });
  }

}
